import { usePartyDocumentUploadMutation } from "Api/Mutations/Party/usePartyDocumentUploadMutation";
import type { SecondDocumentType } from "Components/Onboarding/shared/DocumentsUpload/types";
import { Resources } from "Translations/Resources";

type Parameters = {
  frontSide: File;
  backSide?: File;
  documentType: SecondDocumentType;
  partyPublicID: string;
};

export const useUploadSecondDocumentMutation = () =>
  usePartyDocumentUploadMutation<Parameters>({
    buildFormData: ({ frontSide, backSide, documentType }) => {
      const form = new FormData();
      form.append("SecondIDCardFrontSide", frontSide);
      form.append("SecondDocumentType", documentType);

      if (backSide) {
        form.append("SecondIDCardBackSide", backSide);
      }

      return form;
    },
    successMessage: Resources.Components.Account.SecondDocumentUploadSuccess,
    errorMessage: Resources.Components.Account.SecondDocumentUploadError,
  });
